import { getEmptyLocaleValues } from 'shared/utils/get-empty-locale-values'
import { MailingSettingsEditInterface } from '../types/mailing-settings-interface'

export const defaultValues: MailingSettingsEditInterface = {
  affiliateEmailLink: true,
  emailMessageFooter: '',
  senderEmailAddress: '',
  senderEmailName: '',
  sendgridApiKey: null,
  testEmailAddress: 'dmitriypetrovetss@yandex.ru',
  displayUnsubscribeFromCampaignLink: false,
  unsubscriptionLinkText: getEmptyLocaleValues(),
}
